import React from 'react';
import { ScheduleTable } from '../../components/ScheduleTable';
import { LocationBlock } from '../../components/LocationBlock';
export function WaterfordScheduleLocation() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-3557">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3558">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-3559">
          <div data-id="element-3560">
            <h2 className="text-4xl text-ink mb-8" data-id="element-3561">Class Times</h2>
            <ScheduleTable data-id="element-3562" />
          </div>
          <div data-id="element-3563">
            <h2 className="text-4xl text-ink mb-8" data-id="element-3564">Location Details</h2>
            <LocationBlock data-id="element-3565" />
          </div>
        </div>
      </div>
    </section>;
}